// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_h4-0";
export var fulfillmentPanelBody = "_h4-1";